import { PUT, POST } from "../../../../utils/fetchUtil";
import { cleanJoin } from "../../../../utils/stringUtil";

let customProperties = null;

const select = (document, index, additional, additionalIndex, setSelected) => {
  setSelected({
    preview: 1,
    document: document,
    index: index,
    additional: additional,
    additionalIndex: additionalIndex,
  });
};

const back = (setSelected, setIsBlocking, disabled) => {
  if (disabled === false) {
    setIsBlocking(true);
  }
  setSelected({
    preview: 0,
    document: null,
    index: null,
    additional: null,
    additionalIndex: null,
  });
};

const buttonSetting = (state, setSubmitButton, setSupplement, setProgress, submitButton) => {
  if (state.request !== null) {
    let warning = 0;
    let other = 0;
    let red = 0;
    let green = 0;
    let countedDocs = 0;

    if (state.request.color === "green") {
      green++;
      countedDocs++;
    } else if (state.request.color === "red") {
      red++;
    } else warning++;

    if (state.attachments !== undefined) {
      state.attachments.forEach((attachment) => {
        if (attachment.color === "green") {
          green++;
          countedDocs++;
        } else if (attachment.color === "red") {
          red++;
        } else warning++;
      });
    }
    if (state.supplements !== undefined) {
      state.supplements.forEach((supplement) => {
        other++;
        if (supplement.color === "green") {
          green++;
        } else if (supplement.color === "red") {
          red++;
        } else warning++;
      });
    }
    if (state.finances !== undefined) {
      state.finances.forEach((finance) => {
        other++;
        if (finance.color === "green") {
          green++;
        } else if (finance.color === "red") {
          red++;
        } else warning++;
      });
    }
    if (state.additionalDocs !== undefined) {
      state.additionalDocs.forEach(() => {
        red++;

        if (submitButton === "svi žuti") {
          setSubmitButton("šareno");
        } else if (submitButton === "svi zeleni") {
          setSubmitButton("crveni i zeleni");
        }
      });
    } else if (submitButton === "crveni i zeleni" && red === 0 && warning === 0) {
      setSubmitButton("svi zeleni");
    }

    if (state.letters !== undefined) {
      state.letters.forEach((letter) => {
        other++;
        if (letter.color === "green") {
          green++;
        } else if (letter.color === "red") {
          red++;
        } else warning++;

        if (letter.additionalDocs !== undefined) {
          letter.additionalDocs.forEach((additionalDoc) => {
            other++;
            if (additionalDoc.color === "green") green++;
            else if (additionalDoc.color === "red") red++;
            else warning++;
          });
        }
      });
    }

    let progressDocs = warning + green + red - other - 1;

    setSupplement(red > 0 ? true : false);

    if (warning > 0 && green === 0 && red === 0) {
      setSubmitButton("svi žuti");
      setProgress(0);
    } else if (warning === 0 && green > 0 && red === 0) {
      setProgress(100);
      setSubmitButton("svi zeleni");
    } else if (warning === 0 && green === 0 && red > 0) {
      setProgress(0);
      setSubmitButton("svi crveni");
    } else if (warning === 0 && green > 0 && red > 0) {
      setSubmitButton("crveni i zeleni");

      if (state.request.color === "green") {
        setProgress(50 + Math.round((50 / progressDocs) * (countedDocs - 1)));
      } else {
        setProgress(Math.round((50 / progressDocs) * countedDocs));
      }
    } else {
      setSubmitButton("šareno");

      if (state.request.color === "green") {
        setProgress(Math.round(50 + (50 / progressDocs) * (countedDocs - 1)));
      } else {
        setProgress(Math.round((50 / progressDocs) * countedDocs));
      }
    }
  }
};

const quitMessage = (message, history, setIsBlocking, t) => {
  setIsBlocking(false);
  message.toggle({
    title: t("requests.reviewDocuments.action.quit.title"),
    content: t("requests.reviewDocuments.action.quit.message"),
    onNo: () => message.toggle({}),
    onYes: () => {
      message.toggle({});
      history.push(`/receivedRequests`);
    },
  });
};

const errorMessage = (message, history, setIsBlocking, t) => {
  setIsBlocking(false);
  message.toggle({
    title: t("requests.reviewDocuments.infoBar.errorTitle"),
    content: t("requests.reviewDocuments.infoBar.errorMessage"),
    onNo: () => message.toggle({}),
    noLabel: t("modalMessage.okLabel"),
    hideYes: true,
  });
};

const saveForLaterMessage = (message, history, setIsBlocking, state, t, id, uid) => {
  setIsBlocking(false);

  message.toggle({
    title: t("requests.reviewDocuments.action.save.title"),
    content: t("requests.reviewDocuments.action.save.message"),
    onNo: () => message.toggle({}),
    onYes: () => {
      message.toggle({});
      PUT(
        `/requests/${id}/submissions/${uid}`,
        state,
        () => {
          message.toggle({
            title: t("modalMessage.titleInfo"),
            content: t("requests.reviewDocuments.action.save.info"),
            hideNo: true,
            yesLabel: t("modalMessage.okLabel"),
            onYes: () => {
              message.toggle({});
              history.push(`/requirementsInResolving`);
            },
          });
        },
        (error) => {
          message.toggle({
            title: t("requests.reviewDocuments.action.save.error"),
            content: error,
            hideNo: true,
            yesLabel: t("modalMessage.okLabel"),
            onYes: () => {
              message.toggle({});
            },
          });
        }
      );
    },
  });
};

// If custom message does not exist, use default
const checkMessage = (messageProperties, submitButton, t) => {
  if (!messageProperties?.title && !messageProperties?.content) {
    const messageContent = t(
      submitButton !== "svi zeleni"
        ? "requests.reviewDocuments.action.submit.message"
        : "requests.reviewDocuments.action.submit.messageFinish"
    );
    messageProperties = {
      ...messageProperties,
      title: t("requests.reviewDocuments.action.submit.title"),
      content: messageContent,
    };
  }
  return messageProperties;
};

const submitMessage = (
  message,
  history,
  setIsBlocking,
  state,
  t,
  id,
  uid,
  submitButton,
  messageProperties,
  customProperties
) => {
  let customMessage = checkMessage(messageProperties, submitButton, t);

  setIsBlocking(false);
  message.toggle({
    title: customMessage.title,
    content: customMessage.content,
    onNo: () => {
      message.toggle({});
    },
    onYes: () => {
      message.toggle({});
      POST(
        `/requests/${id}/submissions/${uid}`,
        state,
        () => {
          //if (submitButton !== "svi zeleni" && customProperties?.showSuccessMessage) {
          if (customProperties?.showSuccessMessage) {
            message.toggle({
              title: t("modalMessage.titleInfo"),
              content: t("requests.reviewDocuments.action.submit.info"),
              hideNo: true,
              yesLabel: t("modalMessage.okLabel"),
              onYes: () => {
                message.toggle({});
                if (customProperties.redirect) {
                  const scrollToElement = "linktab-3"; // ID od tab3, hardcoded for now!
                  history.push({
                    pathname: customProperties.redirect,
                    state: { scrollTo: scrollToElement },
                  });
                } else {
                  history.push(`/requirementsInResolving`);
                }
              },
            });
          } else {
            history.push(`/requirementsInResolving?id=${uid}`);
          }
        },
        (error) => {
          message.toggle({
            title: t("requests.reviewDocuments.action.save.error"),
            content: error,
            hideNo: true,
            yesLabel: t("modalMessage.okLabel"),
            onYes: () => {
              message.toggle({});
            },
          });
        }
      );
    },
  });
};

const checkAdditionalDocs = (
  state,
  message,
  history,
  setIsBlocking,
  t,
  id,
  uid,
  submitButton,
  messageProperties = null,
  customProperties = { redirect: null, showSuccessMessage: true }
) => {
  let counterAdditionalDocs = 0;
  let counterAdditionalDoc = 0;
  if (state.additionalDocs.length > 0) {
    counterAdditionalDocs++;
  }
  state.additionalDocs.forEach((additionalDoc) => {
    if (additionalDoc.label === "") {
      counterAdditionalDoc++;
    }
  });
  if (counterAdditionalDocs < counterAdditionalDoc) {
    return errorMessage(message, history, setIsBlocking, t);
  } else if (counterAdditionalDocs === 1 && counterAdditionalDoc === 1) {
    return errorMessage(message, history, setIsBlocking, t);
  } else if (state.additionalDocs.length === 0) {
    submitMessage(
      message,
      history,
      setIsBlocking,
      state,
      t,
      id,
      uid,
      submitButton,
      messageProperties,
      customProperties
    );
  } else {
    submitMessage(
      message,
      history,
      setIsBlocking,
      state,
      t,
      id,
      uid,
      submitButton,
      messageProperties,
      customProperties
    );
  }
};

const checkProgress = (
  message,
  history,
  setIsBlocking,
  state,
  t,
  id,
  uid,
  submitButton,
  disabled,
  dispatch
) => {
  customProperties = { redirect: null, showSuccessMessage: true };

  // Prikaz Buttona ovisno o uvijetima (stanje dokumenata, vrsta zahtjeva...)
  if (disabled === false) {
    // Ako su svi dokumenti u zahtjevu žuti, onda ovi Buttoni, ista logika dalje...
    if (submitButton === "svi žuti") {
      return (
        <div className="buttons is-centered is-grouped">
          <button
            className={cleanJoin("button", "pdf-form-action-button", "no-focus-outline")}
            onClick={() => quitMessage(message, history, setIsBlocking, t)}
          >
            {/* Odustani od pregleda */}
            {t("requests.reviewDocuments.action.quit.label")}
          </button>
        </div>
      );
    } else if (submitButton === "svi zeleni") {
      return (
        <div className="buttons is-centered is-grouped">
          <button
            className={cleanJoin("button", "pdf-form-action-button", "no-focus-outline")}
            onClick={() => saveForLaterMessage(message, history, setIsBlocking, state, t, id, uid)}
          >
            {/* Spremi za kasnije */}
            {t("requests.reviewDocuments.action.save.label")}
          </button>
          <button
            className={cleanJoin("button", "pdf-form-action-button", "no-focus-outline")}
            onClick={() => {
              let messageProperties = {
                type: "",
                title: t("requests.reviewDocuments.action.submit.titleEndRequestProcessing"),
                content: t("requests.reviewDocuments.action.submit.messageFinish"),
              };
              customProperties = { ...customProperties, showSuccessMessage: false };
              dispatch({ type: "noSupplement" });
              checkAdditionalDocs(
                state,
                message,
                history,
                setIsBlocking,
                t,
                id,
                uid,
                submitButton,
                messageProperties,
                customProperties
              );
            }}
          >
            {/* Završi s obradom */}
            {t("requests.reviewDocuments.action.submit.labelEnd")}
          </button>
          <button
            className={cleanJoin("button", "pdf-form-action-button", "no-focus-outline")}
            onClick={() => {
              let messageProperties = {
                type: "",
                title: t("requests.reviewDocuments.action.submit.titleEndProcedure"),
                content: t("requests.reviewDocuments.action.submit.messageEndProcedure"),
              };
              customProperties = { ...customProperties, redirect: "/resolvedRequests" };
              dispatch({ type: "setSolveWithoutDecision" });
              checkAdditionalDocs(
                state,
                message,
                history,
                setIsBlocking,
                t,
                id,
                uid,
                submitButton,
                messageProperties,
                customProperties
              );
            }}
          >
            {/* Završi postupak */}
            {t("requests.reviewDocuments.action.submit.end")}
          </button>
        </div>
      );
    } else if (submitButton === "crveni i zeleni" || submitButton === "svi crveni") {
      return (
        <div className="buttons is-centered is-grouped">
          <button
            className={cleanJoin("button", "pdf-form-action-button", "no-focus-outline")}
            onClick={() => saveForLaterMessage(message, history, setIsBlocking, state, t, id, uid)}
          >
            {/* Spremi za kasnije */}
            {t("requests.reviewDocuments.action.save.label")}
          </button>
          <button
            className={cleanJoin("button", "pdf-form-action-button", "no-focus-outline")}
            onClick={() => {
              checkAdditionalDocs(state, message, history, setIsBlocking, t, id, uid, submitButton);
            }}
          >
            {/* Pošalji */}
            {t("requests.reviewDocuments.action.submit.label")}
          </button>
        </div>
      );
    } else {
      return (
        <div className="buttons is-centered is-grouped">
          <button
            className={cleanJoin("button", "pdf-form-action-button", "no-focus-outline")}
            onClick={() => saveForLaterMessage(message, history, setIsBlocking, state, t, id, uid)}
          >
            {/* Spremi za kasnije */}
            {t("requests.reviewDocuments.action.save.label")}
          </button>
        </div>
      );
    }
    // Modul 'zahtjevi u rješavanju', podmodul "Čekanje dopune zahtjeva" (zuta boja), samo za tu
    // grupu dokumenata idu ovi Buttoni
  } else if (state.statusColor === "yellow") {
    return (
      <div className="buttons is-centered is-grouped">
        <button
          className={cleanJoin("button", "pdf-form-action-button", "no-focus-outline")}
          onClick={() => quitMessage(message, history, setIsBlocking, t)}
        >
          {/* Odustani od pregleda */}
          {t("requests.reviewDocuments.action.quit.label")}
        </button>
        <button
          className={cleanJoin("button", "pdf-form-action-button", "no-focus-outline")}
          onClick={() => {
            dispatch({ type: "setSolveWithoutDecision" });
            let messageProperties = {
              type: "endProcedure",
              title: t("requests.reviewDocuments.action.submit.titleEndProcedure"),
              content: t("requests.reviewDocuments.action.submit.messageEndProcedure"),
            };
            customProperties = { ...customProperties, redirect: "/resolvedRequests" };

            checkAdditionalDocs(
              state,
              message,
              history,
              setIsBlocking,
              t,
              id,
              uid,
              submitButton,
              messageProperties,
              customProperties
            );
          }}
        >
          {/* Završi postupak */}
          {t("requests.reviewDocuments.action.submit.end")}
        </button>
        <button
          className={cleanJoin("button", "pdf-form-action-button", "no-focus-outline")}
          onClick={() => {
            dispatch({ type: "noSupplement" });
            let messageProperties = {
              type: "endRequestProcessing",
              title: t("requests.reviewDocuments.action.submit.titleEndRequestProcessing"),
              content: t("requests.reviewDocuments.action.submit.messageEndRequestProcessing"),
            };
            customProperties = { ...customProperties, showSuccessMessage: false };

            checkAdditionalDocs(
              state,
              message,
              history,
              setIsBlocking,
              t,
              id,
              uid,
              submitButton,
              messageProperties,
              customProperties
            );
          }}
        >
          {/* Završi s obradom i izradi rješenje */}
          {t("requests.reviewDocuments.action.submit.endSolution")}
        </button>
      </div>
    );
  } else {
    return (
      <div className="buttons is-centered is-grouped">
        <button
          className={cleanJoin("button", "pdf-form-action-button", "no-focus-outline")}
          onClick={() => history.push(`/requirementsInResolving?id=${uid}`)}
        >
          {/* Odustani od pregleda */}
          {t("requests.reviewDocuments.action.quit.label")}
        </button>
      </div>
    );
  }
};

export { checkProgress, select, back, buttonSetting };
